import { supabase } from '../lib/supabase';

const productionService = {
  /**
   * Get all production areas with equipment
   */
  async getProductionAreas() {
    try {
      const { data, error } = await supabase?.from('production_areas')?.select(`
          *,
          equipment (*)
        `)?.order('created_at', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching production areas:', error);
      throw new Error(error?.message || 'Failed to fetch production areas');
    }
  },

  /**
   * Get all production alerts
   */
  async getAlerts() {
    try {
      const { data, error } = await supabase?.from('production_alerts')?.select('*')?.eq('resolved', false)?.order('timestamp', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching alerts:', error);
      throw new Error(error?.message || 'Failed to fetch alerts');
    }
  },

  /**
   * Get all workers
   */
  async getWorkers() {
    try {
      const { data, error } = await supabase?.from('workers')?.select('*')?.order('name', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching workers:', error);
      throw new Error(error?.message || 'Failed to fetch workers');
    }
  },

  /**
   * Get all shifts
   */
  async getShifts() {
    try {
      const { data, error } = await supabase?.from('shifts')?.select('*')?.order('date', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching shifts:', error);
      throw new Error(error?.message || 'Failed to fetch shifts');
    }
  },

  /**
   * Get all task assignments
   */
  async getTaskAssignments() {
    try {
      const { data, error } = await supabase?.from('task_assignments')?.select('*')?.order('created_at', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching task assignments:', error);
      throw new Error(error?.message || 'Failed to fetch task assignments');
    }
  },

  /**
   * Get all production lines
   */
  async getProductionLines() {
    try {
      const { data, error } = await supabase?.from('production_lines')?.select('*')?.order('name', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching production lines:', error);
      throw new Error(error?.message || 'Failed to fetch production lines');
    }
  },

  /**
   * Update production area
   */
  async updateProductionArea(id, updates) {
    try {
      const { data, error } = await supabase?.from('production_areas')?.update({
          ...updates,
          updated_at: new Date()?.toISOString()
        })?.eq('id', id)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating production area:', error);
      throw new Error(error?.message || 'Failed to update production area');
    }
  },

  /**
   * Update worker
   */
  async updateWorker(id, updates) {
    try {
      const { data, error } = await supabase?.from('workers')?.update({
          ...updates,
          updated_at: new Date()?.toISOString()
        })?.eq('id', id)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating worker:', error);
      throw new Error(error?.message || 'Failed to update worker');
    }
  },

  /**
   * Update task assignment
   */
  async updateTaskAssignment(id, updates) {
    try {
      const { data, error } = await supabase?.from('task_assignments')?.update({
          ...updates,
          updated_at: new Date()?.toISOString()
        })?.eq('id', id)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating task assignment:', error);
      throw new Error(error?.message || 'Failed to update task assignment');
    }
  },

  /**
   * Update production line
   */
  async updateProductionLine(id, updates) {
    try {
      const { data, error } = await supabase?.from('production_lines')?.update({
          ...updates,
          updated_at: new Date()?.toISOString()
        })?.eq('id', id)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating production line:', error);
      throw new Error(error?.message || 'Failed to update production line');
    }
  }
};

export default productionService;